import './Item.scss';

import React from 'react';
import { ReactNode } from 'react';
import classNames from 'classnames';
import { makeKeyDown } from '@pdcfrontendui/utils';

type ItemProps = {
  onClick?: () => void;
  className?: string;
  selected?: boolean;
  disabled?: boolean;
  id?: string;
  children?: ReactNode;
  ariaLabel?: string;
  role?: React.AriaRole;
};

const Item = ({
  className,
  selected,
  disabled,
  id,
  onClick,
  children,
  ariaLabel,
  role,
}: ItemProps) => (
  <div
    className={classNames('item-component', className, {
      selected,
    })}
    id={id}
    onClick={!disabled ? () => onClick?.() : undefined}
    onKeyDown={makeKeyDown(onClick)}
    tabIndex={onClick ? 0 : undefined}
    role={role ?? (onClick ? 'button' : undefined)}
    aria-selected={selected}
    aria-label={ariaLabel}
    aria-disabled={onClick && disabled}
  >
    {children}
  </div>
);

export default Item;

